import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { Icon, Logo } from "@tenant/ui";
import styles from "./PerkDialogs.module.scss";

export const EarnPointsDialogContent = () => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");
  const { t } = useI18nContext();

  const benefits = [
    t("home.perks.earnPoints.benefit1"),
    t("home.perks.earnPoints.benefit2"),
    t("home.perks.earnPoints.benefit3"),
    t("home.perks.earnPoints.benefit4"),
  ];

  return (
    <>
      <h2 className={cn("dialog-title")}>
        {t("home.perks.earnPoints.dialogTitle")}
      </h2>
      <div className={cn("dialog-content-flex")}>
        <div className={cn("dialog-left-content")}>
          <h4 className={cn("dialog-section-title")}>
            {t("home.perks.earnPoints.howItWorksTitle")}
          </h4>
          <p className={cn("dialog-section-text")}>
            <Trans
              i18nKey="home.perks.earnPoints.howItWorksDescription"
              components={{ bold: <strong /> }}
            />
          </p>

          <h4 className={cn("dialog-section-title")}>
            {t("home.perks.earnPoints.howToRedeemTitle")}
          </h4>
          <p className={cn("dialog-section-text")}>
            <Trans
              i18nKey="home.perks.earnPoints.howToRedeemDescription"
              components={{ bold: <strong /> }}
            />
          </p>
        </div>
        <div className={cn("dialog-right-content")}>
          <ul className={cn("dialog-benefits-list")}>
            {benefits.map((benefit, index) => (
              <li key={index} className={cn("dialog-benefit-item")}>
                <Icon
                  iconName={IconNameEnum.circleCheckedItem}
                  className={cn("dialog-check-icon")}
                />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
          <div className={cn("dialog-logo-container")}>
            <Logo />
          </div>
        </div>
      </div>
    </>
  );
};
